import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Switzerland = () => {
    return <SharedDocumentsComponent permissionId="49" path="Suíça" />
}